import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL, PRICE } from '../data/offer';
import { trackPixelEvent } from '../utils/metaPixel';
type CtaButtonProps = {
  label?: string;
  subLabel?: string;
  className?: string;
};
export function CtaButton({
  label = '¡SÍ, QUIERO QUE MI PERRO VIVA MÁS AÑOS!',
  subLabel = `Acceso inmediato por ${PRICE}`,
  className = ''
}: CtaButtonProps) {
  return <motion.a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" onClick={() => trackPixelEvent('InitiateCheckout', {
    content_name: 'Megapack: Conociendo la Longevidad Canina',
    value: 19990,
    currency: 'ARS'
  })} whileHover={{
    y: -2
  }} whileTap={{
    y: 1,
    scale: 0.99
  }} transition={{
    type: 'spring',
    stiffness: 400,
    damping: 24
  }} className={`group inline-flex w-full max-w-xl flex-col items-center gap-1 rounded-2xl bg-clay-500 px-6 py-5 text-center shadow-[0_10px_0_0_#8A4415] focus:outline-none focus-visible:ring-4 focus-visible:ring-clay-400/50 ${className}`} data-id="element-14" data-mp="qih7rjxb27iq">
      <span className="flex items-center gap-2 text-base font-bold uppercase leading-tight tracking-wide text-white sm:text-lg" data-id="element-15" data-mp="39z9j0yjuvf2j">
        <span aria-hidden="true" data-id="element-16" data-mp="3f070ta0ye73i">👉</span>
        {label}
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform group-hover:translate-x-1" aria-hidden="true" data-id="element-17" data-mp="3jxqea7ptufue" />
      </span>
      <span className="text-sm font-medium text-cream-200" data-id="element-18" data-mp="3sxdewraqfhme">{subLabel}</span>
    </motion.a>;
}